import { API_URL, createHeaders } from './base'

export interface AgentSchedule {
  id: number
  workspace_id: number
  agent_name: string
  cron_expr: string
  enabled: boolean
  next_run_at: string | null
  last_run_at: string | null
  created_at: string
  updated_at: string
}

export interface AgentSchedulePatch {
  cron_expr?: string
  enabled?: boolean
}

export async function listAgentSchedules(): Promise<AgentSchedule[]> {
  const response = await fetch(`${API_URL}/agent-schedules`, {
    headers: createHeaders(),
  })
  if (!response.ok) throw new Error('Failed to fetch agent schedules')
  return response.json()
}

export async function patchAgentSchedule(
  id: number,
  patch: AgentSchedulePatch
): Promise<AgentSchedule> {
  const response = await fetch(`${API_URL}/agent-schedules/${id}`, {
    method: 'PATCH',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(patch),
  })
  if (!response.ok) {
    const text = await response.text().catch(() => '')
    throw new Error(text || 'Failed to update agent schedule')
  }
  return response.json()
}
